<template>
  <header ref="header" :class="{ isHidden: !isVisible, isSticky: isSticky }">
    <div class="container-fluid wrap">
      <div class="header__items">
        <router-link to="/">
          <SfImage v-if="getLogo()" :src="getLogo()" :alt="headerTitle()" class="sf-header__logo" />
          <h1 v-else-if="title">{{ headerTitle() }}</h1>
        </router-link>
        <div class="flexbox-desktop-only main-nav">
          <nav class="sf-header__navigation">
            <SfHeaderNavigationItem v-for="item in navigation" :key="item.name">
              <template slot="desktop-navigation-item">
                <router-link :to="item.path">{{ $t(item.name) }}</router-link>
              </template>
            </SfHeaderNavigationItem>
            <template v-if="!config.global.hiddenTopics">
              <SfHeaderNavigationItem v-for="item in includeInTopMenu" :key="item.SeName">
                <template slot="desktop-navigation-item">
                  <router-link class="text-primary" :to="`/p/${item.SeName}`">{{
                    item.Title
                  }}</router-link>
                </template>
              </SfHeaderNavigationItem>
            </template>
            <template v-if="config.global.hiddenTopics && menuAction">
              <SidebarLink
                :name="menuAction.name"
                :hasBadge="menuAction.hasBadge"
                :badgeLabel="menuAction.badgeLabel"
                :title="menuAction.title"
              >
                <component :is="menuAction.slot" />
              </SidebarLink>
            </template>
          </nav>
        </div>
        <div class="actions flexbox-desktop-only">
          <SidebarLink
            v-for="item in actions"
            :key="item.name"
            :name="item.name"
            :hasBadge="item.hasBadge"
            :badgeLabel="item.badgeLabel"
            :title="item.title"
          >
            <component :is="item.slot" />
          </SidebarLink>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { SfImage, SfHeader } from '@storefront-ui/vue';

import { pages } from '@/modules/page';
import routes from '../../mixins/routes';
import config from '../../mixins/config';
import actionIcons from '../../mixins/actionIcons';
import headerSticky from '../../mixins/headerSticky';
import SidebarLink from '../SidebarLink.vue';

export default {
  name: 'Header',
  mixins: [routes, actionIcons, headerSticky, pages, config],
  components: {
    SfImage,
    SidebarLink,
    SfHeader,
  },
  computed: {
    actions() {
      return this.actionIcons.filter((action) => !action.excludeHeader);
    },
    menuAction() {
      return this.actionIcons.find((action) => action.name === 'menu');
    },
    isCartEmpty() {
      return !!this.cartItemsQty;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint";

/deep/ nav a {
  white-space: nowrap;
}
.main-nav {
  flex-grow: 1;
}
.sf-header__navigation {
  --header-navigation-item-padding: 23px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.isSticky {
  border-bottom: 1px solid var(--c-light);
  z-index: var(--header-z-index, 1);
  background: var(--header-sticky-container-background, var(--c-white));
  position: sticky;
  top: 0;
  width: 100%;
  transition: transform 150ms ease-in-out;
}
.isHidden {
  transition: transform 150ms ease-in-out;
  transform: translate3d(0, -100%, 0);
}

.header__items,
.actions {
  display: flex;
  flex-direction: row;
  vertical-align: middle;
  align-items: center;
}

.actions > * {
  margin: 0 10px;
}

.sf-header-navigation-item {
  flex-grow: initial;
}

.header__items {
  @include flexbox-mobile {
    height: 3.5rem;
  }
}
</style>
